import { configureGa } from './plugins/configure-ga';
import { configureCommitShaVariable } from '@core/utilities/application/appVersion';

// HTTP configuration is deferred to createApp() so it runs after state
// hydration (fetchStateFromApi). configureHttp reads getGlobalConfig().aegis_enabled
// synchronously, which is null until the API has populated the cache when
// the meta tag is gated behind fc-1327-meta-global-config.
configureCommitShaVariable();
configureGa();
